import { render, staticRenderFns } from "./UsersGrid.vue?vue&type=template&id=e8b5e9dc&"
import script from "./UsersGrid.vue?vue&type=script&lang=js&"
export * from "./UsersGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports